import React, { useState, useRef, useEffect } from "react";
import $ from 'jquery';
import axios from 'axios';
import { myConfig } from '../config';
import Header from '../Pages/Header';
import { ContactlessOutlined, SettingsPhone } from "@material-ui/icons";
import Footer from "./Footer";
import lang from './lang.json'

const daily = () => {
  window.location.href= '/grameen/promo?plan=daily&aff_id=1001&click_id=1234&camp_id=4'
  // history.push("/")
}
const weekly = () => {
  window.location.href= '/grameen/promo?plan=weekly&aff_id=1001&click_id=1234&camp_id=4'
  // history.push("/")
}
function BdUat(props) {
  
  return (
    <>
      <Header></Header>
       <div className="landingPage">
        <div className="container">
            <div className="row">
                <div className="col">
                    <div className="heading">SkySports Network</div>
        <div className="subheading" style={{marginBottom:"10%"}}><span> Welcome to skysport network </span>
        <div className="link" id="subscribeMsisdn">
                            <a id="bdu-btns" className="buttondis" style={{marginTop:"30px",background:"#20bd24",color:"white",cursor:"pointer"}} onClick={daily} >Taka 5+16% TAX (VAT & SC)/Day</a>
                            <a id="bdu-btns1" className="buttondis" style={{marginTop:"30px",background:"#20bd24",color:"white",cursor:"pointer"}} onClick={weekly}>Taka 15+16% TAX (VAT & SC)/Week</a>
                          </div> 
        </div>
            <div className="termsData"> <a href="/">click here</a>  to access the SSN.</div>
<div className="termsData"> <a href="/">click here</a> for support and help</div>
                </div>
            </div>
        </div>
    </div>  
    <Footer></Footer>
    </>
  );
}

export default BdUat;